export default {
  line: "Line",
  language: "Language",
  common: [
    "Online services",
    "Cancel Suspension",
    "Whether to spend 10,000 ₽ to make the purchase!"
  ],
  charitables:[//慈善
	  "Welcome to SGM's official information hub! 🌟 Your platform for transparent, authoritative information. Here, you can check our official certification certificates 📜, visit https://sgm-tm.com/ for comprehensive info 🌐, and follow our WhatsApp channel for the latest updates! 📲 Additionally, you'll find positive reviews of SGM from international media like Yahoo, The Associated Press, and Google! 📰 All of this will significantly boost your confidence in the SGM brand and its future development, helping you succeed in the shared mobility business and consistently earn substantial additional income! 💰🚀"
	  ],
  details:[
	  "Task unit price",
	  "Number of order",
	  "Daily income",
	  "level",
	  "Daily profit",
	  "Deposit",
	  "Deposit return date",
	  "days remaining",
	  "My SGM Level"
  ],
  upload: [
    "Uploading...",
    "Wrong format",
    "Uploaded successfully",
    "Upload failed"
  ],
  vanPull: [
    "No more data",
    "No data"
  ],
  login: {
    title:'Login with username and password',
    title_txt:'Log in using your registered mobile phone number',
    text: [
      "Remember username/password",
      "Logging...",
      "Log in now"
    ],
    placeholder: [
      "Please enter phone number",
      "Please enter login password"
    ],
    i18n: [
      "No {title} account? {a} {line}",
      "Register"
    ],
    serve:[
      "Agree to our《privacy policy》or《server terms》"
    ]
  },
  register: {
    text: [
      "Welcome to register",
      "SMS code sending...",
      "Get SMS code",
      "Registering...",
      "Register now",
      "Already have an account? Log in now",
      "Mobile phone number registration",
      "Email registration",
	    "Back to login",
      "Please use an unregistered phone number and email address"
    ],
    placeholder: [
      "Please enter your phone number",
      "Please enter SMS verification code",
      "Please enter the login password",
      "Please confirm your password",
      "Please enter the invitation code",
      "Two passwords are different",
      "Please enter the verification code",
      "Please enter email number",
	    "Cannot start with 0"
    ],
    i18n: [
      "Have an account? {a} {line}",
      "Login"
    ]
  },
  home: {
    lucky: "The event is not yet open",
    map: "Location",
    qywh: "Corporate Culture",
    broadcast: "Congratulations to {member} for inviting a friend to join the SGM online bike-sharing program, being promoted to {vipname}, and receiving {grade} sharing rewards.",
    menu: [
      "VIP area",
      "Video tutorial",
      "Promotion rewards"
    ],
    taskHall: {
      title: [
        "Task hall",
        "Business Hall",
        "Complete tasks to earn profits"
      ]
    },
    title:['Task','News','more','unlock','Please unlock and continue to use~','Check Out','Congratulations!Upgrade Successful','Congradulations~ got two drop cards'],
    memberList: {
      title: "Membership list",
      data: [
        "{member},complete today's {num} order tasks!"
      ]
    },
    businessList: {
      title: "Merchant list",
      data: [
        "{member}",
        "Release {num} single task today"
      ]
    },
    noticeTitle: ["Notice","Previous","Next"],
    tabBar: ["Home","Delivery","T", "Map", "My"],
    msg: "The task is not open",
    video: "No video tutorial",
	  message: "You have new news",
	  bonus:[
		'<p>Enter the code to receive the "Cycling Code" cash reward (1-200000 TJS)</p><p>1. "Cycling Code" is obtained through company activities!</p><p>2. SGM will release the password periodically! Please check for updates daily!</p><p>Deploy bicycles, enjoy the sharing economy life, and easily receive code cash rewards!</p><p>For details, please consult the "Market Manager"</p>',
		'The password is obtained through company activities!',
		'Enter the red Envelope code',
		'Get Cash',
		'Congratulations on winning Ride Cash {amount}TJS',
		'Ride Cash'
	]
  },
  vip: {
    title:[
      "VIP level",
      "Join the membership now to claim tasks",
	  "Under development"
    ],
    user: {
      title: [
        "Your identity",
        "Visitors"
      ],
      label: "Daily Tasks",
      value: [
        "Effective date",
        "One year",
        "Please log in first",
        "Internship validity period",
        "Deposit return countdown",
        "Level VIP validity countdown"
      ],
    },
    list: {
      label: "Daily Order:{number}",
      button: "Join now",
      text: [
        "Daily Profit",
        "Monthly Income",
        "recruitmentation Reward: Everyone",
        "Free",
        "Per order",
        "Rating income",
        "Effective returns",
        "Expiration Date",
        "Year",
        "Day",
        "Validity Period"
      ],
    },
    dialog: [
      "Are you sure to spend {currency} {amount} to become {name}?",
      "You are currently {currname} and cannot be {name}",
      "Are you sure to spend {currency} {amount} to renew {name}?",
    ],
    index: ["Cancel", "Confirm"],
    desc: [
      '{level} Benefits',
      'Basic income',
      'Time',
      'Number of delivery',
      'Income',
      'Daily',
      'Monthly',
      'Yearly',
      'Recuitment income',//8
      'Subordinate level',
      'Recruitment commission ratio',
      'Recruitment Bonus',
      'Level 1 subordinate',
      "Level 2 subordinate",
      "Level 3 subordinate",
      'Single day delivery rebate',
      'Subordinate level',
      'Subordinate dlivery rebate ratio',//17
      'Delivery rebate amount',
      'Level 1 subordinate',
      'Level 2 subordinate',
      'Level 3 subordinate',
      '3 days',
      'Delivery unit price',
      'Probation period details',//24
      'Trial: No purchase required. Deploy shared bikes twice a day, with a commission of 3 TJS per deployment, totaling 6 TJS per day. Free trial for 2 days.',
      'Example of task commission:',
      '<p>Level 1 affiliates who complete 10,000 TJS worth of ride orders per day will earn a commission of 300 TJS.</p><p>Level 2 affiliates who complete 10,000 TJS worth of ride orders per day will earn a commission of 200 TJS.</p><p>Level 3 affiliates who complete 10,000 TJS worth of ride orders per day will earn a commission of 100 TJS. </p>',
      'Referral bonus description:',
      '<p>(Level 1 subordinate) You directly invite A to join, A is your Level 1 subordinate.</p><p>(Level 2 subordinate) A invites B to join, B is your Level 2 subordinate.</p><p>(Level 3 subordinate) B invites C to join, C is your Level 3 subordinate.</p><p>Note: The referral bonus can only be claimed for the highest bonus of the current level of the individual.</p>',
    ]
  },
  charitable:[
	  'Green Philanthropy Initiative',
	  'SGM considers philanthropy and public welfare a corporate mission. We regularly donate supplies and funds to low-income communities, people with disabilities, and schools, and collaborate with non-governmental organizations on green mobility and environmental projects.',
	  'Every shared bike we deploy represents a charitable donation, helping cities reduce emissions while also spreading warmth.',
	  'We uphold the spirit of "cycling, charity and win-win" and light up hope with our wheels. We sincerely invite you to join SGM, ride for a green future, and spread love.',
	  'We encourage you to actively participate in community charitable initiatives and, together, let love and green flourish in every corner of the city.'
  ],
  lucky: {
  	default:[
  		"Lucky pedal",
  		"Remaining number of draws:",
  		"Raffle Record",
  		"Lottery rules",
      "<p>Participate in company activities and get lucky draw opportunities!</p>",
      "Winning User Record",
      ['Congratulations:{member}','Get prizes {profit}'],
      "Congratulations,Get prizes ",
      "close",
      "Your draw times have been used up",
      "Valid until"
  	],
    scattered:[
      'Number of draws',
      'Ride',
      '<p>1.The number of draws is obtained through company activities!</p><p>2.Each draw consumes 1 draw!</p><p>3.After winning the physical prize, please contact the recruitment manager to register your information and receive it!</p>',
      'Reminder',
	  'Important Reminders',
	  'Draw Eligibility',
	  'Obtain draw chances through company activities',
	  'Draw Rules',
	  '1 draw consumed per attempt',
	  'Prize Redemption',
	  'Contact recruitment manager for physical prizes'
	  
    ],
	prizeList:[
		'Lucky Pedal Prize Pool',
		'TJS52 Cash',
		'Instant Withdrawal',
		'TJS88 Cash',
		'TJS205 Cash',
		'TJS19,889 Cash',
		'TJS236,666 Cash',
		'Android Phone',
		'Worth TJS8,000',
		'Upgrade Voucher',
		'TJS600 Value',
		'Double Orders',
		'Daily',
		'SGM Company Exclusive Power Bank',
		'worth TJS1,000',
		'Mechanical Bike',
		'Worth TJS3,000',
		'E-Moped',
		'Worth TJS80,000',
		'iPhone 17',
		'Worth TJS160,000'
	],
  },
  moments:[
	  'Daily Updates',
	  'The official platform for SGM employees to share bike deployment earnings, charitable activities, and wonderful moments. Update Daily for 3 consecutive days to enter cash prize draws (1-200,000 TJS). Join teammates in spreading love and making every ride more valuable!'
  ],
  userLc:{
  	default:[
  	"Cycling Wealth",
  	"Records",
  	"Amount",
  	"Storage period",
  	"Deposit amount",
  	"Please input the deposit amount",
  	"Revenue",
    "Submit",//7
    "Please select the product first",
    "Please select information",
    "Profit",
    "Day",
    "no data",
    "Purchase time",
    "state",
    "End Time",
    "Balance",
    "Today's earnings",
    "One-click purchase"//18
  	],
    tabs: [
      "Product List",
      "Savings record"
     ],
    tips:'<p>VOISP "Wealth Enhance" is the company\'s way to provide all M-level employees with more ways to increase their income. Investment projects are financial investment projects jointly launched by PAGE, banks, asset management companies, etc.!</p><p>Short-term investment: stable income, flexible cycle selection! Short-term idle funds can bring additional income through investment!Long-term investment: Higher returns, cultivate good regular investment savings, have higher returns, and realize your dreams through accumulation!</p>'
  },
  newlist: {
    text: [
     "No records",
    "Expected income",
    "results",
    "buy time",
    "status",
    "End of time"
    ],
    placeholder: [
     "no more data",
      "no data"
    ],
    i18n: [
     "Purchase history",
    ],
	title:[
		"Cycling Wealth Green Savings Plan — A dedicated benefit exclusively designed for SGM's full-time employees!",
		"Your funds are supervised and authorized by financial institutions such as savings banks, and are 100% safe and reliable. SGM cooperates with many leading banks to provide a wide variety of savings products with flexible terms and diverse returns to meet your financial goals at all stages.",
		"We not only encourage you to actively participate in bicycle deployment and embrace low-carbon travel, but also hope you'll plan your personal finances wisely while contributing to a greener future. SGM is proud to walk alongside you as we open a new chapter in green wealth together!"
	]
  },
  product: {
    default: [
      "Promotion account balance",
      "Initial  Savings  Amount",
      "Maximum Savings Amount",
      "Cycle",
      "Daily interest rate",
      "maximum",
      "Project rules",
      "Project amount",
      "Payment method",
      "Initial  Savings  Amount",
      "Daily profit",
      "Release cycle",
      "Estimated income"
    ],
    placeholder: [
      "Return principal and income upon maturity (normal on holidays)",
      ", automatic settlement within 24 hours",
      "{str} = total income {income} {currency} + principal {money} {currency} = total principal and interest {total} {currency}",
      "Security password"
    ]
  },
  user: {
    vipl:"Partner Level",
    hello:"Welcome back",
    default: [
      "My superior",
      "Account",
      "Invitation code",
      "Exit login",
      "Balance",
      "Gold",
      "My wallet",
      "Seal",
      "Restriction",
      "Good",
      "Excellent",
	    "Activate 'Reading Assistant'",
	    "Contact a Hiring Manager",
		  "Operating expensest"
    ],
    myEarnings: {
            grid: ["Balance","Yesterday's earnings","Today's earnings","This week's earnings","This month's earnings","Last month's earnings","Total revenue","Complete the task today(PCE)","Today's remaining tasks(PCE)","Today's commission","Delivery rebate","Referral Rebate"]
        },
    grid: [
      "Balance",
      "Yesterday's earnings",
      "Today's earnings",
      "This week's earnings",
      "This month's earnings",
      "Last month's earnings",
      "Total revenue",
      "Complete the task today(PCE)",
      "Today's remaining tasks(PCE)",
      "Today's commission",
      "Today's rebate"
    ],
    menu: [
      "Task records",
      "Audit task",
      "Release management",
      "Personal information",//3
      "Account binding",
      "Daily statement",
      "Accounting records",//6
      "Shared Invitation",
      "Team Reports",//8
      "Help Manual",//9
      "Credit score",//10
      "Download APP",//11
	    "Lucky pedal",//12
	    "Cycling Wealth",
	    "Reading Assistant",
      "Corporate Culture",
      "Video Instruction",
      "Excellent team",
      "Cycling Wealth",
	    "Follow SGM",
	    "Growth Rewards",
	    "Cycling Code",
      "Deeds Pedal"
    ],
	positions:[
		"My position",
      "Current position",
      "Next position",
      "Directly affiliated M-level member",
      "Level 3 Team M Member",
      "Level 3 team (number of {post})",
      "Meet all requirements to contact the hiring manager to advance your position!",
      "Position Description",
			"Position Apply",
			"Position Info"
	],
	office:[
		"My Job Information",
		"Job Promotion Details",
		"SGM Job Description",
		"Corporate Position",
		"Job Promotion",
		"Receive",
		"Progress of promotion",//6
		"At least ",
		"Conditions not met",//8
		"The direct subordinate needs to sell {num} bicycles.",
		"The team members need to sell {num} bicycles.",
		" members"
	],
	current:[
		"Current Positions",
		"VIP Total members"
	],
	subordinate:[
		"1-level",
		"2-level",
		"3-level",
		"member list",
		"total people",
		"Total revenue",
		"Withdrawal amount",
		"Team income",
		"Member List",
		"user",
		"level",
		"Join Time",
		"Trial Period"
	],
	follow:[
		"SGM Official Channel",
		"Follow the channel to learn more about the latest SGM information!"
	]
  },
  userInfo: {
    default: [
      "Personal information",
      "Head portrait",
      "Mobile number",
      "Add a bank account",
      "Alipay",
      "Real name",
      "Login password",
      "Fund password",
      "Click Settings",
      "Change head portrait",
      "Change login password",
      "Change fund password",
      "Submit",
      "Empty the cache",
	  "Sign out"
    ],
    label: [
      "Original login password",
      "New login password",
      "Confirming passwords",
      "Original money code",
      "New money code",
      "Confirm password"
    ],
    placeholder: [
      "Please enter the original login password",
      "Please enter a new login password",
      "Please confirm the login password",
      "Please enter the original fund password",
      "Please enter the new funds password",
      "Please confirm the fund password"
    ]
  },
  userSet: {
    default: [
      "Real name certification",
      "Detailed information",
      "Bind Alipay",
      "Submit"
    ],
    label: [
      "Real name",
      "QQ",
      "Alipay account",
      "Alipay Name"
    ],
    placeholder: [
      "Please enter a real name(My name is used for cash withdrawal)",
      "Enter QQ number",
      "Please enter Alipay account",
      "Please enter Alipay name"
    ],
    tips: "Reminder: The bound bank card cannot be modified, it is used for your withdrawal"
  },
  bindAccount: {
    default: [
      "Bind Account",
      "View the tutorial",
      "Submit"
    ],
    tabs: [
      "Account",
      "Account",
      "Account"
    ],
    label: [
      "Instructions",
      "Add screenshot",
      "Account"
    ],
    placeholder: "Please enter your {account} account"
  },
  bankCard: {
    default: [
      "Bind bank card",
      "Authenticate now",
      "Submitting ...",
      "Add now",
      "Add bank card"
    ],
    tips: [
      "Please complete real-name authentication before adding a bank card",
      "The account name on your bank card must be consistent with the real-name you authenticated, otherwise you will not be able to withdraw cash successfully."
    ],
    label: [
      "Name",
	  "Bank Name",
      "Bank Account Number",
      "Branch code",
	  "IFSC"
    ],
    placeholder: [
      "Please select the bank name",
      "Please enter the bank account number",
      "Please enter the branch code",
	  "Confirm",
	  "Cancel"	,
	  "Please enter IFSC"
    ]
  },
  wallet: {
    default: [
      "My wallet",
      "Recharge",
      "Withdrawal",
      "Recharge record",
      "Withdrawal record",
      "R",
      "W",
      "₽ recharge"
    ],
    label: [
      "Withdrawal method",
      "Withdrawal amount",
      "Fund password",
      "Submit",
      "Phone number",
      "Email",
      "IFSC",
      "Payment method",
	    "Taxation",
      "Actual amount received"
    ],
    placeholder: [
      "Select withdrawal method",
      "Please input the withdrawal amount",
      "Please input fund password",
      "Please select the withdrawal method",
      "Please enter the payee's mobile phone number",
      "Please enter the payee's email address",
      "Please enter the payee IFSC",
      "Please choose a payment method"
    ],
    msg: [
      "You have not set a fund password yet, please set one first",
      "You haven't linked your bank card yet, please link it first",
      "<p>Withdrawal time:</p><p>Monday: M9</p><p>Tuesday: M8</p><p>Wednesday: M6/M7</p><p>Thursday: M3/M4/M5</p><p>Friday: M1/M2</p><p>(Interns Monday to Sunday)</p><p>9am to 6pm</p>"
    ]
  },
  recharge: {
    default: [
      "Recharge",
      "Recharge details",
      "Recharge record",
      "Available balance {money}, please choose recharge method",
      "Single minimum amount is {currency} {min}, maximum {currency} {max}, handling fee {fee}%",
      "Submitting...",
      "Recharge now",
      "Return",
      "Loading...",
	  "Single minimum amount is ${min}, maximum ${max}, handling fee {fee}%"
    ],
    label: [
      "Recharge amount",
      "Recharge channel",
      "Name of transfer",
      "Payer's Name",
      "Payer's Mobile Phone",
      "Payer UPI Account",
      "Payer's Email",
	    "Transaction order"
    ],
    placeholder: [
      "Please enter the recharge amount",
      "Please select recharge channel",
      "Please enter the name of the transfer",
      "Single minimum amount is {currency} {min}",
      "Single maximum amount is {currency} {max}",
      "Please enter the name of the payer",
      "Please enter the payer's mobile phone number",
      "Please enter the UPI account of the payer",
      "Please enter the payer's email address",
	  "Please upload a screenshot of the transfer",
	  "Please enter the transaction order number"
    ],
    info: [
      "Recharge amount",
      "Order number",
      "Bank",
      "Account no",
      "Name",
      "Copy",
      "{type} Transfer",
      "Transfer screenshot",
      "Submit",
      "IFSC Code",
      "Account type",
      "Processing instructions"
    ],
    tips: [
      "Please select the following method to transfer the matching amount to avoid delay in the financial check.<br>After the transfer, please upload the transfer screenshot as a verification certificate",
      "No need to add friends, scan the QR code to transfer money to me",
      "Please complete the transfer according to the information below",
      "Hint: After successful payment, please contact online service to provide your member account number, recharge amount, order number, depositor account number, recharge time, convenient for financial department to add funds for you in time.",
      "Note: please submit one payment for each transfer",
      "After the transfer, please upload the transfer screenshot as a verification certificate",
	    "Tip: After the payment is successful, please upload a picture of the successful transaction",
      "<p>Recharge reminder: Please read before recharging.</p><p>1: Please pay according to the latest recharge account.</p><p>2: The payment validity period is 10 minutes. Please complete the payment within 10 minutes. If the payment is not made after 10 minutes, the receiving account will be invalid. Please re-obtain the latest recharge account for payment.</p><p>3: The transfer amount must be consistent with the amount you submitted.</p><p>4: If the payment fails, please do not save the previous receiving account. Please resubmit the recharge order to obtain the latest account, otherwise your payment will be deemed invalid.</p><p>5: If the payment is successful, please submit payment voucher as required to facilitate timely verification by the finance department.</p>"
    ]
  },
  postTask:[
	  "title",
	  "Select image",
	  "Deliver",
	  "Please enter a title for the task"
  ],
  task: {
    default: [
      "Delivery LIst",
      "Task requirements",
      "Create",
      "Audit",
      "Open the link",
      "Copy the link",
      "Unit Price",
      "Submit",
      "Waiver",
      "Start serving",
      "In Progress",
      "START  DEPLOYMENT "
    ],
    tabs: [
      "Doing",
      "Audit",
      "Completed",
      "Failed",
      "Malice",
      "Abandoned"
    ],
    msg: "Today's mission has been completed",
    msgSc: "Successfully received",
    msgTime: "After the countdown ends, the task will be completed automatically and closing it early will be invalid!",
    info: [
      "Task details",
      "Task title",
      "Task benefits",
      "Task description",
      "Upload requirements",
      "Submit sample",
      "The user did not submit the sample",
      "Audit notes",
      "Date of audit",
      "Demand side",
      "Release",
      "Copy",
      "Jump",
      "Task steps",
      "Step {index}",
      "Audit sample",
      "No audit sample",
      "Data loading...",
      "Give up the task",
      "Submit completed task",
      "Publish content"
    ],
    index: [
      "Current status",
      "Your current rating is <i style=\"color:#1989fa\">{currVip}</i><br>can only claim the current <i style=\"color:#1989fa\">{currVip}</i> level task<br>do you want to join <i style=\"color:#dd6161\">{vip}</i> level",
      "Join now",
      "Please select task category",
	    "Cancel",
      "Remaining",
      "Free Delivery",
	    "Stay tuned"
    ],
    list: [
      "Task list",
      "Demand side",
      "Remaining",
      "Request",
      "Receiving"
    ],
    show: [
      "Task details",
      "Purchase time",
      "Delivery status",
      "Rental price",
      "Delivery time",
      "Countdown to receive",
      "Start serving",
      "Coding",
	  "UNKONE"
    ]
  },
  postRecord: [
    "Daily Updates",
    "Release",
    "Total",
    "Completed",
    "Deadline",
    "Audit",
    "Rescission",
    "Editors",
	"Daily Updates",
	"Rseceive",
	"SGM Announcement Center",
	"Information Center"
  ],
  dayReport: [
    "Daily statement",
    "Total revenue",
    "My commission",
    "My commission benefits",
    "Delivery completed by subordinates",
    "Subordinate task benefits",
    "PCE",
    "Last 30 days",
    "Quantity",
    "Delivery",
    "Subordinate",
    "Consumption",
    "Date"
  ],
  fundRecord: {
    default: [
      "Expenditure records",
      "Recharge record",
      "Revenue records",
      "R",
      "I",
      "E",
	  "Withdrawal records",
    ],
    tabs: [
      "Revenue",
      "Expenditure",
      "Recharge",
	  "Withdrawal"
    ],
	state: [
		'All',
		'Recharge',	//1 recharge
		'Withdrawal',	//2 withdrawal
		'Post task',	//3 task
		'Plat pump',	//4 pump
		'Rebate',	//5 rebate
		'Delivery completed',	//6 commission
		'Activity rewards',	//7 regment
		'Referral Rewards',	//8 spread
		'Upgrade',	//9 buymembers
		'Cancel task',	//10 revoke
		'Investment income',	//11 transfer_c
		'Transfer to investment',	//12 transfer_r
		'Other revenue', //13 其他
		'Donate',	//14
		'Red envelope',	//15
		'Buy smart robots',//16
		'Lucky pedal',//17
		'VIP Purchase Refund',//18
	]
  },
  promote: [
    "Your best friend",
    "Invite you to join the {title}",
    "Referral code",
    "Copy recommendation code ",
    "Copy the invitation link",
    "Save the QR code",
    "Promotional incentives",
    "Save the poster successfully",//7
    "Failed to save the poster, please try a few more times or save the screenshot",
    "Please screenshot",
    "Save Promotion Poster",
    "Save the promotion poster to your phone<br>If you are unsuccessful, please try a few more times or save the screenshot",
	  "Only official SGM partners are eligible to invite friends to join!",
    "Shared Travel",
    '<p>1. Sharing Rewards: Earn sharing rewards by inviting new users to join SGM.</p><p>2. Sales Commissions: Earn daily commissions from selling shared bicycles.</p><p>3. Company Activities: The company regularly launches various promotional activities, including "Lucky Pedals," "Riding Passwords," and physical prizes.</p><p>4. Cumulative Rewards: Help the company sell and rent more shared bicycles to receive designated cash rewards on the SGM homepage. The more shared bicycles you invite to rent, the higher the reward.</p><p>5. Company Positions: Once you own a certain number of shared bicycles, you can apply for a sales position within the company, such as Level 1, Level 2, Level 3, and Managerial marketing positions, and receive an additional monthly salary.</p><p>Every bicycle deployed represents a step towards financial freedom; every ride contributes to reducing urban emissions. SGM helps you achieve financial freedom while embracing a green lifestyle.</p>',
    "Team sharing travel"
  ],
  teamReport: {
    default: [
      "Search",
      "Team balance",
      "Team benefits",
      "Team recharge",
      "Team withdraw",
      "Number of first charge",
      "Number of first push",
      "Team size",
      "New team",
      "PCE",
      "Me",
      "User",
      "Recharge",
      "Withdrawals",
      "Rebate",
      "Commission",
      "Select date",
      "No data",
      "Withdrawals Amount",
      "Withdrawals Number",
      "Withdrawals Rebate",
      "Number of team withdrawals",//21
      "Team Partner",
      "Recommended total income",
      "Total revenue from delivery rebates",
      "Level 3 Team Total Withdrawals",
      "Grade",
      "Parent",
      "Invitees",
      "User List",
      "Total User"
    ],
    tabs: [
      "Team Reports",
      "My team"
    ],
    team: [
      "Level 1",
      "Level 2",
      "Level 3"
    ]
  },
  help: [
    "Help Manual",
    "Not available"
  ],
  message:[
	  "View message",
	  "No message"
  ],
  credit: [
    "Credit score",
    "Credit note",
    "Credit records",
    "<p>The initial credit score is 60 points.</p><p>1: If the points are less than 50, the daily delivery quantity will be halved.</p><p>2: The score is less than 30 points and daily delivery work cannot be completed.</p><p>3: If the score is less than 10 points, you cannot apply for cash withdrawal.</p><p>Point reward rules:Upgrading the work level will add 5 points, and inviting subordinates to become (formal employees) will add 1 point.</p><p>A negative work attitude, failure to complete delivery on time, and violation of company regulations will affect one’s credit score.</p>",
    "My credit",
    "There is no credit record for the time being"
  ],
  dialog: [
    "Tips",
    "Confirm",
    "Submitting...",
    "Copy succeeded",
    "IOS system version is low and not supported",
    "Registering...",
    "Data loading..."
  ],
  lineList: [
    "Line selection",
    "Current line",
    "Line"
  ],
  serviceCenter: [
    "Customer service",
    "Hi, exclusive customer service",
    "Glad to serve you.",
    "Self service",
    "Online customer service",
    "Recharge customer service",
    "Line customer service"
  ],
  direct:[
  	  'SGM',
  	  'Growth Bonus',
  	  'Activity Description',
  	  '<p>After directly inviting members to join the VIP level, you can receive cash rewards if you meet the conditions!</p><p>For example: if you invite 3 VIP-level members cumulatively, you can directly receive the reward. After receiving it, continue to achieve other goals and continue to receive it.</p><p>SGM exclusive growth reward, each award can only be received once by each employee.</p>',
  	  'Number of Subordinates',
  	  'To be finished',
  	  'Invitation Benefits',
	    'Receive rewards',
      'Received'
  ],
  activity:[
    'Deeds Pedal',
    'Details',
    'Donate',
    'Account Balance',
    'All',
    'Pay',
    'Please enter the donation amount',
    'Thank you for your donation'
  ],
  positions:{
    info:['Position details','Position application','Position','Level 3 Team G-level Regular Employees','Ratio of third-level team members','This month salary', 'Salary settlement', 'Completed', 'To be completed', 'Received','Salary Collection Time'],
    job: ['Submit for review','Under review','Reviewed','Please upload your relevant documents','Comments','Click on the picture to select and upload your ID photo. ','Please upload a photo of the front of your ID card in Photo A. ','Please upload a photo of the back of your ID card in Photo B. ','Please upload a photo of yourself holding your ID card in Photo C. ','Photo A','Photo B','Photo C','Please select the position you want to be promoted to','Position','Basic salary','Additional bonus','Notice To Employees','I have read and agreed to the contents of the 《Position Application Guidelines》','Submit Position application',"Please select a position","Please select Photo A","Please select Photo B","Please select Photo C"]
  },
}